<template>
    <div>
        <el-card class="card-box" style="margin-top: 20px;margin-bottom: 20px;">
            <div slot="header" class="clearfix">
                <span>冰山策略</span>
                <el-button v-if="dataList.length==0" style="float: right; padding: 3px 0"
                           @click="openCreateTurnoverDialog" type="text">新增
                </el-button>
            </div>
            <el-table class="turnover-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column fixed prop="pair" label="交易对" width="150"></el-table-column>
                <el-table-column label="开关">
                    <template slot-scope="scope">
                        <el-switch active-color="#13ce66" :value="scope.row.open"
                                   @change="updateStatus(scope.row, $event)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户id" show-overflow-tooltip></el-table-column>
                <el-table-column prop="upDownKlineSlope" label="k线坡度" width="100"
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'1-100，如果为40则是40%概率买单，60%概率卖单')"></el-table-column>
                <el-table-column prop="minUnilateralAmount" label="最小周期单边交易量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxUnilateralAmount" label="最大周期单边交易量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="priceRange" label="下单价格幅度调整" show-overflow-tooltip></el-table-column>
                <el-table-column prop="minOnceAmount" label="最小单次下单量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxOnceAmount" label="最大单次下单量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="minCreateOrderIntervalTime" label="最小下单间隔" show-overflow-tooltip width="150"
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位-秒。因为最小执行必定是秒，所以用秒更容易计算')"></el-table-column>
                <el-table-column prop="maxCreateOrderIntervalTime" label="最大下单间隔" show-overflow-tooltip width="150"
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'单位-秒。因为最小执行必定是秒，所以用秒更容易计算')"></el-table-column>
                <el-table-column prop="minDifferencePrice" label="最小买卖第一单价差" show-overflow-tooltip></el-table-column>
                <el-table-column prop="maxDifferencePrice" label="最大买卖第一单价差" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="openUpdateTurnoverDialog(scope.row)">修改
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">交易对</span>
                    <el-input maxlength="60" style="width: 70%" size="small" v-model="turnoverData.pair"
                              :disabled="true"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">用户id</span>
                    <el-input maxlength="60" style="width: 70%" size="small" v-model="turnoverData.userId"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最小周期单边交易量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="turnoverData.minUnilateralAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最大周期单边交易量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="turnoverData.maxUnilateralAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">下单价格幅度调整</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="turnoverData.priceRange"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最小单次下单量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="turnoverData.minOnceAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最大单次下单量</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="turnoverData.maxOnceAmount"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最小下单间隔</span>
                    <el-tooltip class="item" effect="dark" content="单位-秒。因为最小执行必定是秒，所以用秒更容易计算" placement="top">
                        <el-input maxlength="200" style="width: 70%" size="small"
                                  v-model="turnoverData.minCreateOrderIntervalTime"></el-input>
                    </el-tooltip>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最大下单间隔</span>
                    <el-tooltip class="item" effect="dark" content="单位-秒。因为最小执行必定是秒，所以用秒更容易计算" placement="top">
                        <el-input maxlength="200" style="width: 70%" size="small"
                                  v-model="turnoverData.maxCreateOrderIntervalTime"></el-input>
                    </el-tooltip>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最小买卖第一单价差</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="turnoverData.minDifferencePrice"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">最大买卖第一单价差</span>
                    <el-input maxlength="200" style="width: 70%" size="small"
                              v-model="turnoverData.maxDifferencePrice"></el-input>
                </div>
                <div style="margin-top: 20px">
                    <span style="padding-right: 20px">k线坡度</span>
                    <el-tooltip class="item" effect="dark" content="1-100，如果为40则是40%概率买单，60%概率卖单" placement="top">
                        <el-input maxlength="200" style="width: 70%" size="small"
                                  v-model="turnoverData.upDownSlope"></el-input>
                    </el-tooltip>

                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="createTurnover">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'Turnover',
        props: {dataList: Array, pair: String},
        data() {
            return {
                loading: false,
                dialogVisible: false,
                dialogTitle: "",
                turnoverData: { //数据对象
                    pair: "",
                    minUnilateralAmount: "",
                    userId: "",
                    maxUnilateralAmount: "",
                    priceRange: "",
                    minOnceAmount: "",
                    maxOnceAmount: "",
                    minCreateOrderIntervalTime: "",
                    maxCreateOrderIntervalTime: "",
                    minDifferencePrice: "",
                    maxDifferencePrice: "",
                    upDownSlope: "",
                    open: true
                }
            };
        },
        methods: {
            queryList() {
                this.$emit('refreshData');
            },
            updateStatus(row, value) {
                api.updateBingshanStatus({id: row.id, open: value}).then(response => {
                    if (response.code == 0) {
                        this.queryList();
                    } else {
                        this.$message.success('操作失败');
                    }
                });
            },
            createTurnover() {
                if (this.turnoverData.pair == "") {
                    this.$message.success('请输入交易对!');
                    return
                }
                if (this.turnoverData.userId == "") {
                    this.$message.success('请输入用户id!');
                    return
                }
                if (this.turnoverData.minUnilateralAmount == "") {
                    this.$message.success('请输入最小周期单边交易量!');
                    return
                }
                if (this.turnoverData.maxUnilateralAmount == "") {
                    this.$message.success('请输入最大周期单边交易量!');
                    return
                }
                if (this.turnoverData.priceRange == "") {
                    this.$message.success('请输入下单价格幅度调整!');
                    return
                }
                if (this.turnoverData.minOnceAmount == "") {
                    this.$message.success('请输入最小单次下单量!');
                    return
                }
                if (this.turnoverData.maxOnceAmount == "") {
                    this.$message.success('请输入最大单次下单量!');
                    return
                }
                if (this.turnoverData.minCreateOrderIntervalTime == "") {
                    this.$message.success('请输入最小下单间隔!');
                    return
                }
                if (this.turnoverData.maxCreateOrderIntervalTime == "") {
                    this.$message.success('请输入最大下单间隔!');
                    return
                }
                if (this.turnoverData.minDifferencePrice == "") {
                    this.$message.success('请输入最小买卖第一单价差!');
                    return
                }
                if (this.turnoverData.maxDifferencePrice == "") {
                    this.$message.success('请输入最大买卖第一单价差!');
                    return
                }
                if (this.turnoverData.upDownSlope == "") {
                    this.$message.success('请输入k线坡度!');
                    return
                }
                this.loading = true;
                api.updateBingshanConfig(this.turnoverData).then(response => {
                    if (response.code == 0) {
                        this.dialogVisible = false;
                        this.$message.success(this.dialogTitle + '成功');
                        this.queryList();
                    } else {
                        this.$message.success(this.dialogTitle + '失败');
                    }
                });
                setTimeout(() => {
                    this.loading = false;
                }, 1000);
            },
            openCreateTurnoverDialog() {
                this.turnoverData.pair = this.pair;
                this.dialogTitle = "增加";
                this.dialogVisible = true;
            },
            openUpdateTurnoverDialog(row) {
                this.turnoverData = { //数据对象
                    pair: row.pair,
                    minUnilateralAmount: row.minUnilateralAmount,
                    userId: row.userId,
                    maxUnilateralAmount: row.maxUnilateralAmount,
                    priceRange: row.priceRange,
                    minOnceAmount: row.minOnceAmount,
                    maxOnceAmount: row.maxOnceAmount,
                    minCreateOrderIntervalTime: row.minCreateOrderIntervalTime,
                    maxCreateOrderIntervalTime: row.maxCreateOrderIntervalTime,
                    minDifferencePrice: row.minDifferencePrice,
                    maxDifferencePrice: row.maxDifferencePrice,
                    upDownSlope: row.upDownKlineSlope,
                    open: row.open
                }
                this.dialogTitle = "修改";
                this.dialogVisible = true;
            },
            clearData() {
                this.turnoverData = { //数据对象
                    pair: this.pair,
                    minUnilateralAmount: "",
                    userId: "",
                    maxUnilateralAmount: "",
                    priceRange: "",
                    minOnceAmount: "",
                    maxOnceAmount: "",
                    minCreateOrderIntervalTime: "",
                    maxCreateOrderIntervalTime: "",
                    minDifferencePrice: "",
                    maxDifferencePrice: "",
                    upDownSlope: "",
                    open: true
                }
            },
            renderTipsHeader(h, {column}, index) {
                return h(
                    'div', [
                        h('span', column.label),
                        h('el-tooltip', {
                            props: {
                                effect: 'dark',
                                content: index,
                                placement: 'top'
                            },
                        }, [
                            h('i', {
                                class: 'el-icon-question',
                                style: 'color:#409EFF;margin-left:5px;'
                            })
                        ])
                    ]
                );
            }
        },
        created() {
            this.turnoverData.pair = this.pair;
        }
    };
</script>

<style lang="less" scoped>
    .preview-opration {
    }

    .turnover-list {
        border: 1px solid #f2ece2;
        clear: both;
        width: 100%;
        .turnover-table {
            margin-top: 30px;
        }
    }
</style>
